import constants from 'crm/common/constants'

const {mingChuangTagGroupNamePrefix} = constants

export function parseMCTags(tags) {
    if (Array.isArray(tags)) {
        return tags.map((tag) => {
            if (typeof tag === 'string') {
                const index = tag.indexOf(':')
                const groupName = tag.substring(0, index)
                const tagName = tag.substring(index + 1)
                const excludedNames = tags.filter((v) => {
                    const name = v.substring(v.indexOf(':') + 1)
                    return name !== tagName
                })
                if (excludedNames.length === tags.length - 1) {
                    return tagName
                }
                return `${groupName.replace(mingChuangTagGroupNamePrefix, '')}：${tagName}`
            }
            return ''
        })
    }
    return []
}

export function findDuplicateCorpTagNames(allCorpTags) {
    if (Array.isArray(allCorpTags)) {
        const allTagNames = allCorpTags.reduce((accumulator, currentGroup) => {
            const {tag: tags} = currentGroup
            if (Array.isArray(tags)) {
                const tagNames = tags.map((v) => v.name)
                accumulator.push(...tagNames)
            }
            return accumulator
        }, [])
        const sortedNames = allTagNames.sort()
        const results = []
        for (let i = 0; i < sortedNames.length - 1; i++) {
            if (sortedNames[i + 1] === sortedNames[i] && !results.includes(sortedNames[i])) {
                results.push(sortedNames[i])
            }
        }
        return results
    }
    return []
}
